import { render } from "./IconExpiredSession.vue?vue&type=template&id=77b9ac42"
import script from "./IconExpiredSession.vue?vue&type=script&lang=js"
export * from "./IconExpiredSession.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__